import { render, staticRenderFns } from "./sku_attr_item.vue?vue&type=template&id=09a9297b"
import script from "./sku_attr_item.vue?vue&type=script&lang=js"
export * from "./sku_attr_item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports